import React, { useEffect, useMemo, useState } from "react";

import "../StuStyles/LiveJobs.css";

import {
  FaMapMarkerAlt,
  FaClock,
  FaMoneyBillWave,
} from "react-icons/fa";

import {
  toast,
  ToastContainer,
} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";

import ApiService from "../../../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

const Jobs = () => {

  const navigate = useNavigate();

  const [jobs, setJobs] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  /* =========================================================
      PAGINATION
  ========================================================= */

  const [page, setPage] =
    useState(1);

  const pageSize = 3;

  /* =========================================================
      LOAD JOBS
  ========================================================= */

  useEffect(() => {

    fetchJobs();

  }, []);

  /* =========================================================
      FETCH STUDENT PUBLIC JOBS
  ========================================================= */

  const fetchJobs =
    async () => {

      try {

        setLoading(true);

        console.log(
          "FETCHING STUDENT PUBLIC JOBS..."
        );

        /* =====================================================
            STUDENT PUBLIC API
            https://nhrc.onrender.com/student/all
        ===================================================== */

        const response =
          await JobAPI.getAllJobs();

        console.log(
          "STUDENT JOB API RESPONSE :",
          response
        );

        console.log(
          "STUDENT JOB API DATA :",
          response?.data
        );

        /* =====================================================
            EXTRACT ARRAY
        ===================================================== */

        let allJobs = [];

        if (
          Array.isArray(
            response?.data
          )
        ) {

          allJobs =
            response.data;

        } else if (
          Array.isArray(
            response?.data?.jobs
          )
        ) {

          allJobs =
            response.data.jobs;

        } else if (
          Array.isArray(
            response?.data?.data
          )
        ) {

          allJobs =
            response.data.data;

        } else {

          allJobs = [];
        }

        console.log(
          "ALL JOBS :",
          allJobs
        );

        /* =====================================================
            FILTER ONLY APPROVED JOBS
        ===================================================== */

        const approvedJobs =
          allJobs.filter(
            (job) => {

              const status = (
                job?.status ||

                job?.approval_status ||

                job?.job_status ||

                ""
              )
                .toString()
                .toUpperCase()
                .trim();

              return (

                status ===
                  "APPROVED"

                ||

                status ===
                  "ACTIVE"

                ||

                status ===
                  "OPEN"

                ||

                status === ""
              );
            }
          );

        console.log(
          "APPROVED JOBS :",
          approvedJobs
        );

        /* =====================================================
            FORMAT JOBS
        ===================================================== */

        const formattedJobs =
          approvedJobs.map(
            (job) => ({

              id:
                job?.job_id ||

                job?.id ||

                "",

              job_id:
                job?.job_id ||

                job?.id ||

                "",

              title:
                job?.title ||

                "N/A",

              company_name:
                job?.company_name ||

                "N/A",

              department:
                job?.department ||

                "",

              work_mode:
                job?.work_mode ||

                "",

              location:
                job?.location ||

                "N/A",

              locality:
                job?.locality ||

                "",

              min_salary:
                Number(
                  job?.min_salary || 0
                ),

              max_salary:
                Number(
                  job?.max_salary || 0
                ),

              min_experience:
                Number(
                  job?.min_experience || 0
                ),

              max_experience:
                Number(
                  job?.max_experience || 0
                ),

              required_skills:
                job?.required_skills ||

                "N/A",

              qualification_required:
                job?.qualification_required ||

                "N/A",

              application_deadline:
                job?.application_deadline ||

                "N/A",

              roles_responsibilities:
                job?.roles_responsibilities ||

                "",

              perks_benefits:
                job?.perks_benefits ||

                "",

              openings:
                job?.openings || 0,

              logo:
                job?.logo ||

                "",

              status:
                job?.status ||

                "APPROVED",

              creator_role:
                job?.creator_role ||

                "",

              created_at:
                job?.created_at ||

                "",

              company_website:
                job?.company_website ||

                "",

              whatsapp_number:
                job?.whatsapp_number ||

                "",
            }))
          ;

        console.log(
          "FORMATTED JOBS :",
          formattedJobs
        );

        setJobs(
          formattedJobs
        );

      } catch (error) {

        console.log(
          "GET JOBS ERROR :",
          error
        );

        console.log(
          "ERROR RESPONSE :",
          error?.response?.data
        );

        console.log(
          "ERROR STATUS :",
          error?.response?.status
        );

        toast.error(

          error?.response?.data
            ?.detail ||

          error?.response?.data
            ?.message ||

          "Failed to load jobs"
        );

        setJobs([]);

      } finally {

        setLoading(false);
      }
    };

  /* =========================================================
      PAGINATION LOGIC
  ========================================================= */

  const totalPages =
    Math.ceil(
      jobs.length / pageSize
    );

  const currentJobs =
    useMemo(() => {

      const startIndex =
        (page - 1) * pageSize;

      const endIndex =
        startIndex + pageSize;

      return jobs.slice(
        startIndex,
        endIndex
      );

    }, [jobs, page]);

  return (

    <div className="livejobs-container">

      <ToastContainer />

      {/* =====================================================
          HEADING
      ===================================================== */}

      <h3 className="livejobs-heading">

        Jobs

      </h3>

      {/* =====================================================
          LOADING
      ===================================================== */}

      {loading && (

        <div className="text-center mt-5">

          <h5>

            Loading Jobs...

          </h5>

        </div>
      )}

      {/* =====================================================
          JOB LIST
      ===================================================== */}

      {!loading && (

        <div className="livejobs-list">

          {currentJobs.map(
            (
              job,
              index
            ) => {

              const uniqueId =

                job?.job_id ||

                job?.id ||

                index;

              return (

                <div
                  className="livejobs-card"
                  key={uniqueId}
                >

                  <div className="job-details">

                    {/* =================================================
                        HEADER
                    ================================================= */}

                    <div className="main-hed">

                      <div>

                        <h3>

                          {job?.title ||
                            "N/A"}

                        </h3>

                        <p className="job-meta">

                          <FaMoneyBillWave className="icon-jo" />

                          {" "}

                          {job?.min_salary ||
                            0}

                          {" - "}

                          {job?.max_salary ||
                            0}

                          {" "}

                          LPA

                        </p>

                      </div>

                      {/* =================================================
                          LOGO
                      ================================================= */}

                      {job?.logo && (

                        <div className="job-img-box">

                          <img
                            src={
                              job.logo
                            }
                            alt={
                              job.title
                            }
                            className="job-img"
                          />

                        </div>
                      )}

                    </div>

                    {/* =================================================
                        CONTENT
                    ================================================= */}

                    <div className="currnt-cont">

                      {/* LEFT */}

                      <div className="m-2">

                        <p>

                          <strong>

                            Company:

                          </strong>

                          {" "}

                          {job?.company_name ||
                            "N/A"}

                        </p>

                        <p>

                          <FaMapMarkerAlt className="icon-jo" />

                          {" "}

                          {job?.location ||
                            "N/A"}

                        </p>

                        <p>

                          <FaClock className="icon-jo" />

                          {" "}

                          {job?.min_experience ||
                            0}

                          {" - "}

                          {job?.max_experience ||
                            0}

                          {" "}

                          years

                        </p>

                      </div>

                      {/* RIGHT */}

                      <div className="m-2 ms-5">

                        <p>

                          <strong>

                            Period:

                          </strong>

                          {" "}

                          {
                            job?.application_deadline ||

                            "N/A"
                          }

                        </p>

                        <p>

                          <strong>

                            Skills:

                          </strong>

                          {" "}

                          {
                            job?.required_skills ||

                            "N/A"
                          }

                        </p>

                        <p>

                          <strong>

                            Qualification:

                          </strong>

                          {" "}

                          {
                            job?.qualification_required ||

                            "N/A"
                          }

                        </p>

                      </div>

                    </div>

                    {/* =================================================
                        BUTTON
                    ================================================= */}

                    <div className="current-btn">

                      <button
                        className="livejobs-btn"
                        onClick={() =>

                          navigate(
                            `/student/jobs/${uniqueId}`,
                            {
                              state: {
                                job,
                              },
                            }
                          )

                        }
                      >

                        View

                      </button>

                    </div>

                  </div>

                </div>
              );
            }
          )}

          {/* =====================================================
              EMPTY
          ===================================================== */}

          {!loading &&
            jobs.length === 0 && (

              <p className="text-center text-muted mt-4">

                No jobs available right now

              </p>
            )}

        </div>
      )}

      {/* =====================================================
          PAGINATION BUTTONS
      ===================================================== */}

      {!loading &&
        jobs.length > 0 && (

          <div className="d-flex justify-content-center align-items-center gap-3 mt-4 mb-4">

            <button
              className="btn btn-outline-secondary"
              disabled={page === 1}
              onClick={() =>
                setPage(page - 1)
              }
            >

              Previous

            </button>

            <span className="fw-bold">

              Page {page} of {totalPages}

            </span>

            <button
              className="btn btn-outline-secondary"
              disabled={
                page === totalPages
              }
              onClick={() =>
                setPage(page + 1)
              }
            >

              Next

            </button>

          </div>
        )}

    </div>
  );
};

export default Jobs;